import { Sku } from "../../../types";
import {
  createGAItem,
  saveItemListContext,
  sendSelectItemEvent,
} from "../../analytics/google-analytics";
import { i18n } from "../../i18n";
import { buildProductPageUrl, buildRetailerPageUrl } from "../../link-builder";
import { ProductShippingType } from "./ProductShippingType";
import { RetailerInformation } from "../RetailerInformation";

export const SellersItem = ({
  item,
  gaListId,
  gaListName,
}: {
  item: Sku;
  gaListId?: string;
  gaListName?: string;
}) => {
  const analyticsOnClick = () => {
    if (gaListId && gaListName) {
      sendSelectItemEvent(gaListId, gaListName, [createGAItem(item)]);
      saveItemListContext(item.id.toString(), gaListId, gaListName);
    }
  };

  return (
    <li
      data-reveal="true"
      data-testid="multi-merchant-list-item"
      class="tw:p-4 tw:border-2 tw:border-fruugo-border-control tw:rounded-lg tw:opacity-0 tw:translate-y-3 tw:transition-all tw:duration-300 tw:ease-out"
    >
      <div class="tw:flex tw:items-center tw:mb-4 tw:gap-4">
        <p class="tw:text-xl tw:font-semibold tw:text-fruugo-green tw:mb-0">
          {item.displayPrice}
        </p>
        <ProductShippingType
          shippingType={
            item.shipping?.cheapestShippingMethod?.shippingType ?? "STANDARD"
          }
          shippingPrice={
            item.shipping?.cheapestShippingMethod?.shippingExcludingFeeFormatted
          }
        />
      </div>
      <RetailerInformation
        retailerName={item.retailerName}
        retailerLink={buildRetailerPageUrl(item.retailerName, item.retailerId)}
        isPremiumSeller={item.premiumSeller}
        storefrontLogoUrl={item.storefrontLogo}
      />
      <a
        href={buildProductPageUrl(
          item.title ?? item.titleBeforeTranslation,
          item.productId,
          item.id
        )}
        onClick={() => analyticsOnClick()}
        class="tw:bg-fruugo-blue-secondary tw:border-0 tw:text-white tw:mb-0 tw:lg:mb-0 tw:px-8 tw:py-2 tw:inline-block tw:no-underline tw:hover:bg-fruugo-dark-blue tw:focus:bg-fruugo-dark-blue tw:mt-4"
      >
        {i18n("product.view-product")}
      </a>
    </li>
  );
};
